import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import componentQueries from 'react-component-queries';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { MainLayout } from './components/Layout';
import PageSpinner from './components/PageSpinner';
import 'react-toastify/dist/ReactToastify.css';
import './styles/reduction.scss';
// routers
import { pathRoutes } from './Routes';
import ConditionRouter from './Routes/ConditionRouter';
import HelperRouter from './Routes/HelperRouter';
// import lib
import { decodeJWT, isLogin } from './lib/auth';
import { getAuthToken } from './lib/localStorage';
// import reducer
import { setAuthAccount } from './redux/reducers/auth';
import isEmpty from './lib/isEmpty';


const App = ({ breakpoint }) => {

    const dispatch = useDispatch();
    // redux-state
    const { role, restriction } = useSelector(state => state.auth);
    // function
    useEffect(() => {
        if (isLogin()) {
            const { status, decoded } = decodeJWT(getAuthToken());
            if (status === true) {
                setAuthAccount(dispatch, decoded)
            }
        }
    }, [dispatch])

    // useEffect(() => {
    //     const url = new URL(window.location.href);

    //     if (url.search.includes("p=") || url.search.includes("q=")) {
    //         window.history.replaceState({}, "", url.pathname);
    //     }
    // }, []);

    return (
        <BrowserRouter basename={'/'}>
            <ToastContainer />
            {/* <HelperRouter /> */}
            <MainLayout breakpoint={breakpoint}>
                <React.Suspense fallback={<PageSpinner />}>
                    <Routes>
                        {
                            pathRoutes && pathRoutes.length > 0 && pathRoutes.map((item, key) => {
                                if (role === 'superadmin' || isEmpty(role)) {
                                    return (
                                        <Route key={key} exact={true} path={item.path} name={item.name} element={
                                            <ConditionRouter type={item.type}>
                                                <item.component />
                                            </ConditionRouter>
                                        } />
                                    )
                                } else if (role === 'subadmin' && restriction && restriction.includes(item.path)) {
                                    return (
                                        <Route key={key} exact={true} path={item.path} name={item.name} element={
                                            <ConditionRouter type={item.type}>
                                                <item.component />
                                            </ConditionRouter>
                                        } />
                                    )
                                } else {
                                    return null;
                                }
                            })
                        }
                        {/* <Route path="*" element={<div>Page Not Found</div>} /> */}
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </React.Suspense>
            </MainLayout>
        </BrowserRouter>
    );
}

const query = ({ width }) => {
    if (width < 575) {
        return { breakpoint: 'xs' };
    }

    if (576 < width && width < 767) {
        return { breakpoint: 'sm' };
    }

    if (768 < width && width < 991) {
        return { breakpoint: 'md' };
    }

    if (992 < width && width < 1199) {
        return { breakpoint: 'lg' };
    }

    if (width > 1200) {
        return { breakpoint: 'xl' };
    }

    return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);